import React from 'react';
import { Link } from 'react-scroll';
import {
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaInstagram,
    FaWhatsapp
} from 'react-icons/fa';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const quickLinks = [
        { name: 'Home', to: 'hero' },
        { name: 'About', to: 'about' },
        { name: 'Services', to: 'services' },
        { name: 'Why Choose Us', to: 'why-choose' },
        { name: 'Reviews', to: 'reviews' },
        { name: 'Contact', to: 'contact' }
    ];

    const services = [
        'Home Nurse',
        'Physiotherapy',
        'Home Attendant',
        'Senior Citizen Care',
        'House Maid',
        'House Cook',
        'Caretaker'
    ];

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-col">
                        <div className="footer-brand">
                            <Logo variant="white" width={80} height={80} />
                        </div>
                        <p className="footer-description">
                            Leading provider of premium old age care and home healthcare services in Mumbai,
                            Navi Mumbai, and Thane since 2021.
                        </p>
                        <div className="social-links">
                            <a href="https://www.instagram.com/adarsholdagecareservices/" className="social-link" aria-label="Instagram">
                                <FaInstagram />
                            </a>
                            <a href="https://wa.me/919082033873" className="social-link" aria-label="WhatsApp">
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>

                    <div className="footer-col">
                        <h4>Quick Links</h4>
                        <ul className="footer-links">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.to}
                                        spy={true}
                                        smooth={true}
                                        offset={-80}
                                        duration={500}
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>Our Services</h4>
                        <ul className="footer-links">
                            {services.map((service, index) => (
                                <li key={index}>
                                    <a href="tel:9082033873">{service}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>SEO Pages</h4>
                        <ul className="footer-links">
                            <li><a href="/">Old Age Care</a></li>
                            <li><a href="/">Elder Care Services</a></li>
                            <li><a href="/">Senior Citizen Care</a></li>
                            <li><a href="/">Home Healthcare</a></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>Contact Info</h4>
                        <div className="contact-info">
                            <div className="contact-item">
                                <FaPhone />
                                <a href="tel:9082033873">9082033873</a>
                            </div>
                            <div className="contact-item">
                                <FaEnvelope />
                                <a href="mailto:info@adarsholdagecarehomeservices.com">info@adarsholdagecarehomeservices.com</a>
                            </div>
                            <div className="contact-item">
                                <FaMapMarkerAlt />
                                <span>Mumbai, Navi Mumbai & Thane, Maharashtra, India</span>
                            </div>
                        </div>
                        <div className="working-hours">
                            <h5>Available 24/7</h5>
                            <p>Round-the-clock service for your convenience</p>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>&copy; {currentYear} Adarsh Old Age Care Home Services. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;